export const PRODUCT_PRICE_TYPES = {
  FIXED: 'FIXED',
  VARIABLE: 'VARIABLE',
};

export type ProductPriceType = typeof PRODUCT_PRICE_TYPES[keyof typeof PRODUCT_PRICE_TYPES];
